<template>
    <!--https://www.svgrepo.com/svg/374378/queue -->
    <svg
        fill="#000000"
        xmlns="http://www.w3.org/2000/svg"
        width="20px"
        height="20px"
        viewBox="0 0 100 100"
        enable-background="new 0 0 100 100"
        xml:space="preserve"
    >
        <path
            d="M67.6,20.1c-2.9,0-5.4,2.1-6.4,5c3.8,1.7,6.7,5.4,7.7,9.9c3.1-0.7,5.4-3.7,5.4-7.3
	C74.3,23.4,71.3,20.1,67.6,20.1z"
        />
        <path
            d="M73.8,37.9c-1.3,1.2-2.9,2-4.7,2.3c-0.3,2.7-1.3,5.2-2.8,7.2h11.1c1.4,0,2.5-1.1,2.5-2.5v-1.2
	C79.9,41,76.9,39.3,73.8,37.9z"
        />
        <path
            d="M63.2,50c-2,1.8-4.5,2.9-7.2,2.9c-0.2,3.1-1.1,5.9-2.5,8.3h14c1.6,0,3-1.3,3-3V57
	C70.4,53.7,66.8,51.7,63.2,50z"
        />
        <path
            d="M50.3,65.2c-2.8,2.8-6.6,4.4-10.6,4.4c-4.1,0-7.9-1.7-10.7-4.6C24.4,67.2,20,70,20,74.1V76
	c0,2.2,1.8,3.9,3.9,3.9h31.3c2.2,0,3.9-1.8,3.9-3.9v-1.8C59.1,70,54.9,67.3,50.3,65.2z"
        />
        <ellipse cx="39.6" cy="51.6" rx="10.7" ry="11.8" />
        <path
            d="M55.7,29.5c-3.7,0-6.8,2.7-7.7,6.5c3.7,2.4,6.4,6.5,7.5,11.2c0.1,0,0.1,0,0.2,0c4.4,0,8-4,8-8.9
	C63.8,33.5,60.2,29.5,55.7,29.5z"
        />
    </svg>
</template>

<script>
export default {
    name: "QueueIcon",
};
</script>

<style scoped></style>
